import React from 'react'

// TODO: Not hardcode key
const bingKey = 'AqNCnevexy5KeCqjr0i_ODC432TItuqKlKVwRB8hNvwkFQIyI6w0D3iZCiGV9g3F'
let L

class Map extends React.Component {
  static propTypes = {
    pins: React.PropTypes.array,
    docIds: React.PropTypes.object,
    initialBounds: React.PropTypes.object,
    geometry: React.PropTypes.object,
    onGeometryChange: React.PropTypes.func
  }

  /**
   * Set up map when mounting
   */
  componentDidMount () {
    if (!global.document) return // do not render map on server

    const { pins, initialBounds, docIds, geometry, onGeometryChange } = this.props

    L = require('leaflet')
    require('leaflet.label')
    require('leaflet-draw')

    const BingLayer = require('_/utils/bingLayer')
    L.Icon.Default.imagePath = '/images/'

    const el = React.findDOMNode(this)

    const bingRoad = new BingLayer(bingKey, { type: 'road' })
    const bingAerial = new BingLayer(bingKey, { type: 'aerial' })
    const bingAerialLabels = new BingLayer(bingKey, { type: 'aerialwithlabels' })

    const usLatLng = L.latLng(39.50, -96.35)
    const usZoomLevel = 4

    this.inactiveIcon = L.icon({
      iconUrl: './images/marker-icon.png',
      iconRetinaUrl: './images/marker-icon-2x.png'
    })

    this.activeIcon = L.icon({
      iconUrl: './images/marker-icon-bu.png',
      iconRetinaUrl: './images/marker-icon-bu-2x.png'
    })

    this.map = L.map(el, {
      minZoom: 2,
      maxZoom: 20,
      center: usLatLng,
      zoom: usZoomLevel,
      layers: [ bingRoad ],
      attributionControl: false
    })

    this.map.addControl(L.control.layers({
      Road: bingRoad,
      Hybrid: bingAerialLabels,
      Satellite: bingAerial
    }))

    if (initialBounds && initialBounds.coordinates.length) {
      const boundsLayer = L.GeoJSON.geometryToLayer(initialBounds)
      this.map.fitBounds(boundsLayer.getBounds())
    }

    setTimeout(() => {
      this.map.invalidateSize()
      if (pins) this.setPins(pins)
      if (onGeometryChange) this.addDrawTools(geometry)
      if (docIds && docIds.size) this.highlightPins(docIds)
    }, 200)
  }

  componentDidUpdate () {
    this.map.invalidateSize()
  }

  /**
   * Handle changes manually to map from the outside
   * @param  {[type]} nextProps - new properties passed in
   */
  componentWillReceiveProps (nextProps) {
    if (!L) {
      L = require('leaflet')
      require('leaflet.label')
      require('leaflet-draw')
    }

    if (nextProps.pins !== this.props.pins) {
      this.setPins(nextProps.pins)
    }
    if (nextProps.docIds) this.highlightPins(nextProps.docIds)

    if (nextProps.geometry !== this.props.geometry) {
      this.drawGroup.clearLayers()

      if (nextProps.geometry) {
        this.drawGroup.addLayer(L.GeoJSON.geometryToLayer(nextProps.geometry))
        this.map.fitBounds(this.drawGroup.getBounds())
      }
      else {
        if (nextProps.initialBounds && nextProps.initialBounds.coordinates.length) {
          const boundsLayer = L.GeoJSON.geometryToLayer(nextProps.initialBounds)
          this.map.fitBounds(boundsLayer.getBounds())
        }
      }
    }
  }

  addDrawTools (geometry) {
    this.drawGroup = new L.FeatureGroup()
    this.map.addLayer(this.drawGroup)

    if (geometry) {
      this.drawGroup.addLayer(L.GeoJSON.geometryToLayer(geometry))
      this.map.fitBounds(this.drawGroup.getBounds())
    }

    const drawControl = new L.Control.Draw({
      position: 'topright',
      edit: {
        featureGroup: this.drawGroup
      },
      draw: {
        polyline: false,
        rectangle: false,
        circle: false,
        marker: false,
        polygon: {
          allowIntersection: false,
          shapeOptions: {
            color: '#0000ff'
          }
        }
      }
    })
    this.map.addControl(drawControl)

    this.map.on('draw:created', ::this.handleChange)
    this.map.on('draw:deleted', ::this.handleChange)
    this.map.on('draw:edited', ::this.handleChange)
  }

  highlightPins (docIds) {
    for (const markerId in this.markerLu) {
      this.markerLu[markerId].setIcon(this.inactiveIcon)
    }
    for (const docId of docIds) {
      const marker = this.markerLu[docId]
      if (!marker) continue
      marker.setIcon(this.activeIcon)
    }
  }

  handleChange (evt) {
    const flayer = this.drawGroup.getLayers()[0]

    if (flayer && evt.layer) { // layer exists!
      this.drawGroup.removeLayer(flayer)
    }

    if (evt.type === 'draw:deleted') {
      return this.props.onGeometryChange(null)
    }

    const layer = evt.layer || flayer

    this.props.onGeometryChange(layer.toGeoJSON().geometry)
    this.drawGroup.addLayer(layer)
  }

  /**
   * Cleans up map when unmounting
   */
  componentWillUnmount () {
    if (this.map) this.map.remove()
  }

  setPins (pins) {
    if (this.markerLayer) {
      this.map.removeLayer(this.markerLayer)
      // clean event listeners
      this.markerLayer.getLayers().forEach(
        (layer) => layer.clearAllEventListeners()
      )
      this.markerLayer.clearLayers()
      this.markerLayer = null
    }

    this.markerLu = {}
    if (!pins.length) return

    const markers = []

    for (const pin of pins) {
      const marker = L.marker(pin.latLng)
        .bindLabel(pin.label, { direction: 'auto', pane: 'popupPane' })
        .on('click', pin.onClick)
      this.markerLu[pin.id] = marker
      markers.push(marker)
    }

    this.markerLayer = L.featureGroup(markers)
    this.markerLayer.addTo(this.map)
    this.map.fitBounds(this.markerLayer.getBounds())
  }

  render () {
    return (
      <div className="redi-component-map" />
    )
  }
}

export default Map



// WEBPACK FOOTER //
// ./modules/shared/components/map.js